<template>
  <div class="page-error">
    <img :src="errorImg" />
    <!-- <p class="code">404</p> -->
    <p class="error">{{ this.errorText }}</p>
    <div style="margin-top: 28px;">
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
  import { QtReportRouteTo404, QtReportRouteTo405 } from '@/layout/utils/report-qt.js'
  export default {
    data () {
      return {
        routePath: '/',
        hasRouteData: true
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.routePath = from.fullPath
        vm.getPathModule(from)
      })
    },
    beforeRouteUpdate(to, from, next) {
      next()
      this.getPathModule(from)
    },
    computed: {
      errorText() {
        return this.hasRouteData ? '您访问的地址可能有误, 找不到对应页面' : '您访问的模块代码未上线...'
      },
      errorImg() {
        return this.hasRouteData ? require('./404.png') : require('./405.png')
      }
    },
    methods: {
      // 判断菜单信息表里面是否有当前路由
      getPathModule(from) {
        const path = this.$route.path
        const menuData = this.$store.state.menus
        console.log('path', path, menuData.hasOwnProperty(path))
        if (menuData && menuData.hasOwnProperty(path)) {
          this.hasRouteData = false
          QtReportRouteTo405(from)
        } else {
          this.hasRouteData = true
          QtReportRouteTo404(from)
        }
      },
      goBack () {
        this.$router.erpReplace(this.routePath)
      },
    }
  }
</script>

<style lang='scss'>
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/layout/layout/error-page/404.vue